<template>
  <div id="embed_video" class="embed-video-ad">
    <div v-if="!show404 && !show403" class="player_video">
      <uep-player
        v-if="!isLoading && token"
        :video-file-name="token"
        :query="query"
        @readyPlayer="readyPlayer"
      ></uep-player>
    </div>
    <div class="meta-data" style="color: azure">
      <div class="bloc1">
        <div class="title">{{ title }}</div>
        <div class="button_transcription" v-if="transcriptionFileOption">
          <button v-on:click="downloadFile">
            &nbsp; <i class="icon-Icon-download"></i> &nbsp;&nbsp;Télécharger la
            transcription &nbsp;&nbsp;
          </button>
        </div>
      </div>
      <div class="bloc2">{{ description }}</div>
    </div>
    <page404 v-if="show404 && !show403"></page404>
    <page403 v-if="show403"></page403>
  </div>
</template>
<script>
import LoadingScreen from "./Loading.vue";
import Page404 from "./404.vue";
import Page403 from "./403.vue";

export default {
  name: "embed_video",
  components: { LoadingScreen, Page404, Page403 },
  data() {
    return {
      crypttext: null,
      skin: "",
      plugin: "",
      query: {},
      token: "",
      title: "",
      transcriptionFileOption: "",
      description: "",
      isLoading: true,
      show404: false,
      show403: false,
    };
  },
  methods: {
    string_to_slug(str) {
      str = str.replace(/^\s+|\s+$/g, ""); // trim
      str = str.toLowerCase();

      // remove accents, swap ñ for n, etc
      var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to = "aaaaeeeeiiiioooouuuunc------";
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }

      str = str
        .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
        .replace(/\s+/g, "-") // collapse whitespace and replace by -
        .replace(/-+/g, "-"); // collapse dashes

      return str;
    },
    downloadFile() {
      fetch(this.transcriptionFileOption)
        .then((response) => response.blob())
        .then((blob) => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = this.string_to_slug(this.title) + ".pdf";
          link.click();
        })
        .catch(console.error);
    },
    readyPlayer(param) {
    },
    fetchVideoEmbed(token) {

      let self = this;
      this.$service
        .getDataCryptedUrlByToken({ uid: token })
        .then(
          function (resp) {
            self.title = resp.data.data.infoOptions.title;
            self.description = resp.data.data.infoOptions.description;
            self.colorOptions = "61,188,215";
            self.transcriptionFileOption =
              resp.data.data.transcriptionFileOption;
          }.bind(this)
        )
        .catch(
          function (error) {
            self.isLoading = false;
            self.show404 = true;
          }.bind(this)
        );
    },
  },
  created() {
    this.token = this.$route.params.token;
    this.query = Object.assign(
      {
        skin: "dark",
        plugin: "navigation",
        color: "61,188,215",
        token: this.$route.query.token ? this.$route.query.token : this.token,
      },
      this.$route.query
    );
    if (this.$route.query.op && this.$route.query.op === "1") {
      this.query.withoutApi = true;
    } else {
      this.query.withoutApi = false;
    }
    let referer = document.referrer.split("/")[2]
      ? document.referrer.split("/")[2]
      : document.referrer;
    if (referer) {
      this.query.referer = referer;
    }
    this.show404 = false;
    this.show403 = false;
    this.isLoading = false;

    this.fetchVideoEmbed(this.$route.params.token);
  },
};
</script>
<style lang="scss">
div#embed_video.embed-video-ad,
.embed-video-ad .player_video {
  width: 100%;
  background-color: #333333;
  overflow: hidden;
}
.embed-video-ad .player_video {
  height: 80%;
}
@font-face {
  font-family: "dark-skin";
  src: url("../assets/fonts/dark-skin.eot?hyc1ys");
  src: url("../assets/fonts/dark-skin.eot?hyc1ys#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/dark-skin.ttf?hyc1ys") format("truetype"),
    url("../assets/fonts/dark-skin.woff?hyc1ys") format("woff"),
    url("../assets/fonts/dark-skin.svg?hyc1ys#dark-skin") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
.embed-video-ad {
  [class^="icon-"],
  [class*=" icon-"] {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "dark-skin" !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;

    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .icon-player-volume1:before {
    content: "\e1900";
    color: #fff;
  }
  .icon-audio-description-1:before {
    content: "\e1901";
    color: #fff;
  }
  .icon-audio-description-AD:before {
    content: "\e1902";
  }
  .icon-player-cc:before {
    content: "\e1903";
    color: #fff;
  }
  .icon-Icon-Back:before {
    content: "\e1904";
  }
  .icon-player-play:before {
    content: "\e1905";
    color: #fff;
  }
  .icon-Icon-forrward:before {
    content: "\e1906";
  }
  .icon-Icon-quality:before {
    content: "\e1907";
    color: #fff;
  }
  .icon-Icon-download:before {
    content: "\e1908";
  }
  .icon-player-replay:before {
    content: "\e1909";
    color: #fff;
  }
}

div#embed_video.embed-video-ad
  .video-js.skin-dark.vjs-v5
  .vjs-big-play-button:before {
  font-family: dark-skin !important;
  padding-top: 5px;
  padding-left: 8px;
}
div#embed_video.embed-video-ad
  .video-js.skin-dark.vjs-v5.vjs-ended
  .vjs-big-play-button:before {
  font-family: dark-skin !important;
  content: "\e1909" !important;
  padding-left: 0px;
}

div#embed_video.embed-video-ad
  .video-js.skin-dark.vjs-v5
  .vjs-big-play-button:before {
  font-family: dark-skin !important;
  content: "\e1905" !important;
}

div#embed_video.embed-video-ad .video-js.skin-dark .vjs-big-play-button {
  background-color: RGBA(61, 188, 215, 0.9);
  border-radius: 50%;
  /* padding-bottom: 81PX; */
}

div#embed_video.embed-video-ad .video-js.skin-dark .vjs-big-play-button {
  background-color: RGBA(61, 188, 215, 0.9);
  border-radius: 50%;
  /* padding-bottom: 81PX; */
}

div#embed_video.embed-video-ad .video-js.skin-dark .vjs-big-play-button {
  background-color: RGBA(61, 188, 215, 0.9);
  border-radius: 50%;
  /* padding-bottom: 81PX; */
}

div#embed_video.embed-video-ad .video-js.skin-dark:hover .vjs-big-play-button {
  background-color: RGBA(61, 188, 215, 0.9);
}

div#embed_video.embed-video-ad .video-js.skin-dark .vjs-control-bar {
  background-color: RGB(51, 51, 51) !important;
}

div#embed_video.embed-video-ad .video-info-container {
  display: none;
}
div#embed_video.embed-video-ad
  .video-js.skin-dark
  .vjs-control.vjs-button.vjs-fullscreen-control {
  display: none;
}

div#embed_video.embed-video-ad {
  .video-js.skin-dark {
    &.vjs-user-inactive.vjs-playing .vjs-text-track-display {
      bottom: 3em;
    }

    &:not(.vjs-rich-media) .vjs-tech {
      min-height: calc(100% - 3em) !important;
      max-height: calc(100% - 3em) !important;
    }
    &.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-progress-control {
      position: absolute;
      left: 2vw;
      right: 0;
      width: 100%;
      height: 0.3em;
      top: -0.3em;
      transition: 0.1s ease-in-out;
      max-width: calc(100% - 4vw);
    }

    &.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-control-bar {
      visibility: visible;
      opacity: 1;
      transform: none;
      transition: none;
    }
  }

  .meta-data {
    color: #ffffff;
    border-top: 2px solid #ffffff;

    display: flex;
    flex-direction: column;
    align-content: flex-start;
    align-items: flex-start;
    height: 20%;
    padding: 20px;
  }

  .title {
    font-size: 18px;
  }

  .bloc1 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }

  .button_transcription button {
    background: transparent;
    color: #ffffff;
    border: 1px solid RGB(151, 151, 151);
    border-radius: 3px;
    padding-left: 2px;
    padding-right: 2px;
  }
  .bloc2 {
    font-size: 14px;
    align-items: start;
    align-content: start;
    text-align: start;
    padding-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EmbedVideoByTokenAd.vue